import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'

import { getInfoClient } from '@/lib/hooks/useHyperClient'
import { removeTrailingZeros } from '@/lib/utils/hyper'

export function addSymbolSuffix(name: string, suffix: '-PERP' | '-SPOT' = '-PERP') {
  if (name.endsWith(suffix)) {
    return name
  }
  return name + suffix
}
const infoClient = getInfoClient()
export function useAllMidsQuery() {
  const infoClient = getInfoClient()
  return useQuery({
    queryKey: ['allMidsQuery'],
    queryFn: async () => {
      const mids = await infoClient.allMids()
      return mids
    },
    staleTime: 30 * 60 * 1000,
  })
}
// export function useHLCoinInfo() {
//   const { data: metaData, refetch } = usePerpetualsCoinMeta()
//   const { data: allMids = {}, refetch: refetchAllMids } = useAllMidsQuery()
//   const getCoinInfoByName = (suffixedName: string) => {
//     if (!metaData?.[0]) {
//       return null
//     }
//     const meta = metaData[0]
//     const index = meta.universe.findIndex((_meta) => {
//       return _meta.name === suffixedName
//     })
//     // const suffixedNameWithoutSuffix = suffixedName.replace(/-PERP$|-SPOT$/, '')
//     // console.log(allMids[suffixedName], 'allMids', getDecimalFormPrice(allMids[suffixedName]))
//     if (index !== undefined) {
//       return {
//         ...meta.universe[index],
//         index,
//         tokenDecimal: getDecimalFormPrice(`${allMids[suffixedName]}`) - 1,
//       }
//     }
//     return null
//   }
//   return {
//     getCoinInfoByName,
//   }
// }

// const hlTransport = new HttpTransport()
// const infoClient = new InfoClient({ transport: hlTransport })
export function usePerpetualsCoinMeta() {
  return useQuery({
    queryKey: ['perpetualsCoinMeta'],
    queryFn: async () => {
      const meta = await infoClient.meta()
      return meta
    },

    staleTime: 30 * 60 * 1000,
  })
}
export function useHLCoinInfo() {
  const { data: metaData, refetch } = usePerpetualsCoinMeta()
  const getCoinInfoByName = useCallback((name: string) => {
    if (!metaData?.universe) {
      return null
    }
    // console.log('getCoinInfoByName', name, metaData.universe)
    const index = metaData.universe.findIndex((meta) => {
      return meta.name === name
    })
    if (index !== undefined) {
      const rawData = metaData.universe[index]
      if (!rawData) {
        return null
      }
      return {
        ...rawData,
        index,
        decimals: Math.max(6 - rawData.szDecimals, 0),
      }
    }
    return null
  }, [metaData?.universe])
  const formatPrice = useCallback((price: number, symbol: string, removeTrailingZerosFlag = true) => {
    // console.log('formatPrice', price, symbol)

    const coinInfo = getCoinInfoByName(symbol)
    // console.log('coinInfo', coinInfo)
    if (!price || Number.isNaN(price))
      return '$0.00'

    // Format based on magnitude
    return removeTrailingZerosFlag ? removeTrailingZeros(price.toFixed(coinInfo?.decimals || 2)) : price.toFixed(coinInfo?.decimals || 2)
  }, [getCoinInfoByName])
  return {
    getCoinInfoByName,
    formatCoinPrice: formatPrice,
  }
}
